'use client';

import React, { useEffect } from 'react';

import { Button } from '@nextui-org/react';
import Link from 'next/link';
import { ROUTES } from '@/shared/routes/routes';
import { isSERVER } from '@/entities/cart/utils';

/** События, которые считаются признаком того, что пользователь реально взаимодействует со страницей. */
const ACTIVITY_EVENTS = ['scroll', 'pointerdown', 'keydown', 'wheel'] as const;

/**
 * Cookie-баннер. Обычный fixed-блок БЕЗ модального оверлея: NextUI Modal
 * (даже с transparent backdrop) накрывает страницу fullscreen-обёрткой и
 * перехватывает все клики — из-за этого, например, не нажимались звёзды
 * в форме отзыва, пока баннер открыт.
 */
export const CookiesModal = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  useEffect(() => {
    if (isSERVER) return;
    if (localStorage.getItem('isAcceptCookies') === 'true') return;

    const handleActivity = () => {
      setIsVisible(true);
    };
    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, handleActivity, {
        passive: true,
        once: true,
      }),
    );
    return () => {
      ACTIVITY_EVENTS.forEach((event) =>
        window.removeEventListener(event, handleActivity),
      );
    };
  }, []);

  const accept = () => {
    setIsVisible(false);
    if (!isSERVER) {
      localStorage.setItem('isAcceptCookies', 'true');
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      role="dialog"
      aria-label="Уведомление об использовании файлов cookie"
      className="fixed inset-x-3 bottom-24 z-40 flex flex-col items-center gap-3 rounded-2xl border border-default-200 bg-white p-4 shadow-lg md:inset-x-auto md:bottom-6 md:right-6 md:max-w-md"
    >
      <p className="text-small font-normal text-default-700">
        Мы используем файлы cookie для вашего удобства пользования сайтом.{' '}
        <Link href={ROUTES.cookies}>Подробнее</Link>
      </p>

      <Button onClick={accept} color="primary" variant="bordered">
        Окей, понятно
      </Button>
    </div>
  );
};
